<template>
  <div class="card modal-card">
    <div class="modal-card-body pd-0">
      <header class="bandeau-modal card-header">
      </header>
      <div class="center">
        <div class="columns is-gapless">
          <div class="column mgt-20px">
            <h1 class="title is-size-3">
              {{ modulePresseActive ?
                $t('ajoutEditContrat.echeancier.detailProduit.titleProduit')
                : $t('ajoutEditContrat.echeancier.detailProduit.titlePatrimoine')}}
            </h1>
          </div>
        </div>
      </div>
      <div class="card-content">
        <div class="mgt-10px has-text-weight-bold has-text-default">
          {{ $t('ajoutEditContrat.echeancier.detailProduit.infoEcheance', {
          bailleur: echeance.tiers.nomCommercial,
          date: getDate(echeance.dateEcheance), montantTtc: formatDevise(echeance.montantTtc) }) }}
        </div>
        <div
          class="overflow-y-auto overflow-x-hidden mgt-10px max-height-320 is-height-320"
          v-if="!modulePresseActive">
          <ligne-emplacement :emplacement="emplacement" class="mgt-10px"
                             :dateDebut="dateDebut"
                             :dateFin="dateFin"
                             :index="index"
                             :afficherCheckbox="false"
                             v-for="(emplacement, index) in emplacements" :key="index">
          </ligne-emplacement>
        </div>
        <div
          class="overflow-y-auto overflow-x-hidden mgt-10px max-height-320 is-height-320"
          v-else>
          <v-client-table
            ref="produitTable"
            :data="produitsInformations"
            :columns="columns"
            :options="options">
            <template slot="reference" slot-scope="props">
              <router-link-blank
                  v-if="getRoutingReference(props.row)"
                  v-bind="getRoutingReference(props.row)">
              </router-link-blank>
            </template>
            <template slot="supportCommercial" slot-scope="props">
              {{ $t(getType(props.row)) }}
            </template>
            <template slot="libelle" slot-scope="props">
              {{ props.row.libelle }}
            </template>
          </v-client-table>
        </div>
        <div>
          <div class="mgt-40px">
            <b-field>
              <div class="boutonAction">
                <a class="button" @click="$parent.close()">
                  {{ $t('ajoutEditContrat.echeancier.detailProduit.close')}}
                </a>
              </div>
            </b-field>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import formatDate from '@/services/general/formatDate';
import { formatDevise } from '@/services/general/filters/formatDevise';
import { getByProduitsIds } from '@/api/gabed/materiel';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import ligneEmplacement from '@/components/gabed/general/ligneEmplacement';
import { getEmplacementDispositifMaterielAndFaceFromListeMateriel }
  from '@/services/gabed/materiel/getEmplacementDispositifMaterielAndFaceFromListeMateriel';
import { getAll as getAllProduit } from '@/api/produit/index';
import cloneDeep from 'lodash/cloneDeep';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON, TEXTS,
} from '@/configuration/clientTableConf';
import { CATEGORIE_PRODUIT } from '@/configuration/catalogue/produitConf';
import routerLinkBlank from '@/components/general/routerLinkBlank';

const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'p_ContratCommunDetailProduitListe',
  props: {
    produits: {
      type: Array,
    },
    echeance: {
      type: Object,
    },
    dateDebut: {
      type: Date,
      required: true,
    },
    dateFin: {
      type: Date,
      required: true,
    },
  },
  data() {
    return {
      emplacements: [],
      produitsInformations: [],
    };
  },
  components: {
    ligneEmplacement,
    routerLinkBlank,
  },
  computed: {
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    columns() {
      const column = ['reference', 'supportCommercial', 'libelle'];
      return column;
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          reference: this.$t('ajoutEditContrat.produit.tab.reference'),
          supportCommercial: this.$t('ajoutEditContrat.produit.tab.type'),
          libelle: this.$t('ajoutEditContrat.produit.tab.libelle'),
        },
        sortable: ['reference', 'libelle', 'supportCommercial'],
        texts: texts,
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
      };
    },
    modulePresseActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.modulePresse.key);
    },
  },
  methods: {
    formatDevise(montant) {
      return formatDevise(montant);
    },
    getDate(date) {
      return formatDate(date);
    },
    async getPatrimoineInfos() {
      const materiels = (await getByProduitsIds(
        this.produits.map((produit) => produit.produitId),
      )).data.result;
      this.emplacements = getEmplacementDispositifMaterielAndFaceFromListeMateriel(
        materiels,
        this.produits.map((produit) => produit.produitId),
      );
      if (this.emplacements.length === 1) {
        this.emplacements.forEach((emplacement) => {
          emplacement.open = true;
          emplacement.dispositifs.forEach((dispositif) => {
            dispositif.open = true;
          });
        });
      }
    },
    async getProduitsInfos() {
      const newProduits = (
        await getAllProduit({ query: { ids: this.produits.map(p => p.produitId) } })
      ).data.result.items;
      this.produitsInformations = newProduits;
    },
    getType(row) {
      return CATEGORIE_PRODUIT.find(p => p.code === row.supportCommercial.categorieVente)?.libelle ?? '';
    },
    getRoutingReference(row) {
      const categorie = CATEGORIE_PRODUIT
        .find(p => p.code === row.supportCommercial.categorieVente);
      if (!categorie) return null;
      const routes = {
        message: row.reference,
        to: {
          name: categorie.routeDetail,
          params: { id: row.id },
        },
      };
      return routes;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      if (this.modulePresseActive) {
        await this.getProduitsInfos();
      } else {
        await this.getPatrimoineInfos();
      }
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
